import { t } from "../../i18n";
import { Brain } from "lucide-react";
import { Markdown } from "../Markdown";
import { useInteractionDisclosure } from "./MessageActivity.utils";

export function ThinkingBlock({
  content,
  streaming = false,
  label = t("Thinking"),
  compact = false,
}: {
  content: string;
  streaming?: boolean;
  label?: string;
  compact?: boolean;
}) {
  const { open, onToggle } = useInteractionDisclosure(false);
  return (
    <details
      open={open}
      onToggle={onToggle}
      className={
        compact
          ? "rounded-lg border border-stone-200 bg-white/60 dark:border-white/10 dark:bg-black/10"
          : "rounded-xl border border-stone-200 bg-stone-50/70 text-xs dark:border-white/10 dark:bg-white/[0.03]"
      }
    >
      <summary className="flex cursor-pointer list-none items-center gap-2 px-3 py-2 font-semibold text-stone-500 marker:content-none">
        <Brain size={compact ? 13 : 14} /> {label}
      </summary>
      {open && (
        <div className="border-t border-stone-200 p-3 leading-5 text-stone-500 dark:border-white/10 dark:text-stone-400">
          <Markdown streaming={streaming}>{content}</Markdown>
        </div>
      )}
    </details>
  );
}
